import axios, { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

export const normaliseError = (error: unknown): Error | undefined => {
  if (error instanceof Error) return error;
  if (typeof error === 'string' && error) return new Error(error);
  return error ? new Error(JSON.stringify(error)) : undefined;
};

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { detail?: unknown; message?: unknown } | string | undefined;
    if (typeof data === 'string' && data.trim()) {
      return data;
    }

    if (data && typeof data === 'object') {
      const detail = data.detail ?? data.message;
      if (typeof detail === 'string' && detail.trim()) {
        return detail;
      }
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
};

export const isNotFoundError = (error: unknown): boolean => axios.isAxiosError(error) && error.response?.status === 404;

export const errorHandler = (error: AxiosError) => {
  console.error('Request failed:', {
    message: error.message,
    code: error.code,
    status: error.response?.status,
    url: error.config?.url,
    method: error.config?.method,
  });
  if (axios.isCancel(error)) {
    return;
  }
  enqueueSnackbar({
    variant: 'error',
    message: error.message || 'Oops.. something went wrong',
  });
};
